<template>
	<div class="pages" v-loading="listLoading">
		<div v-for='(item,index) in templateData.TemplateContent.Controls' :key='index'>
			<Digit v-if='item.Property.Control=="Number"' :data-val='item'></Digit>
			<Contact v-if='item.Property.Control=="Condition"' :data-val="item"></Contact>
			<Dates v-if='item.Property.Control=="Date"' :data-val="item"></Dates>
			<Version v-if='item.Property.Control=="Text"' @child-event='getTextVal' :data-val="item"></Version>
			<Money v-if='item.Property.Control=="Money"' :data-val="item"></Money>
			<Tips v-if='item.Property.Control=="Tips"' :data-val="item"></Tips>
			<File v-if='item.Property.Control=="File"' :data-val="item"></File>
			<Table v-if='item.Property.Control=="Table"' @child-event='tableOperation' :data-val='item'></Table>
			<Selector v-if='item.Property.Control=="Selector"' @child-event='getSelectorVal' :data-val='item'></Selector>
			<Textarea v-if='item.Property.Control=="Textarea"' :data-val='item'></Textarea>
			<Choose v-if='item.Property.Control=="Contact"' @child-event='clickChoose' :data-val='item'></Choose>
			<img v-if='item.Property.Control=="Image"' class="large-img" src="https://wework.qpic.cn/wwpic/684061_ufljHMrOTvi42ph_1600580505/0"
			 preview="1">
			<img v-if='item.Property.Control=="Image"' class="large-img" src="https://wework.qpic.cn/wwpic/457327_o9SXSYGtTLSv1mU_1600580530/0"
			 preview="1">

		</div>
		
		<Button class="submit-process" v-on:click='submit' v-bind:disabled="isDisabled" v-bind:loading="formLoading" size="large"
		 type="primary"> 提交 </Button>
	</div>
</template>

<script>
	/**
	 * Version 为Text文本组件
	 */
	import wimg from "w-previewimg";
	import Digit from '../components/Number.vue'
	import Contact from '../components/Contact.vue';
	import Dates from '../components/Date.vue';
	import Version from '../components/Text.vue';
	import Money from '../components/Money.vue';
	import Tips from '../components/Tips.vue';
	import File from '../components/File.vue';
	import Table from '../components/Table.vue';
	import Selector from '../components/Selector.vue';
	import Textarea from '../components/Textarea.vue';
	import Choose from '../components/Choose.vue';
	import wx from 'weixin-js-sdk'
	import stringUtils from "../assets/js/stringUtil.js";
	import {
		initWxConfig
	} from '../api/jssdk.js';
	import {
		getTemplateInfo,
		submitProcess
	} from '@/api/approval'
	import {
		getRelation
	} from '@/api/employee'
	import {
		getImageMediaId
	} from '@/api/file'

	var isSubmit = false;

	var template = {
		TemplateContent: {
			Controls: []
		}
	};
	export default {
		components: {
			Contact,
			Dates,
			Version,
			Money,
			Tips,
			File,
			Table,
			Digit,
			Selector,
			Textarea,
			Choose
		},
		data() {
			return {
				templateData: template,
				relationList: null,
				logInfo: null,
				templateId: "",
				spNo: null,
				formLoading: false,
				listLoading: false,
				isDisabled: false,
				medias:[]
			}
		},
		created() {
			initWxConfig(this);
			
			this.logInfo = this.getLoginUserInfo();
			this.templateId = this.$route.query.templateId;
			this.spNo = this.$route.query.spNo;
			this.getTemplate();
			stringUtils.setAddIsShow(false);
		},
		methods: { //方法
			
			clickChoose(dataVal, name) {
				window.wx.invoke("selectEnterpriseContact", {
					"fromDepartmentId": 0, // 必填，表示打开的通讯录从指定的部门开始展示，-1表示自己所在部门开始, 0表示从最上层开始
					"mode": "single", // 必填，选择模式，single表示单选，multi表示多选
					"type": ["user"], // 必填，选择限制类型，指定department、user中的一个或者多个
					"selectedDepartmentIds": [], // 非必填，已选部门ID列表。用于多次选人时可重入，single模式下请勿填入多个id
					"selectedUserIds": [] // 非必填，已选用户ID列表。用于多次选人时可重入，single模式下请勿填入多个id
				}, function(res) {
					if (res.err_msg == "selectEnterpriseContact:ok") {
						if (typeof res.result == 'string') {
							res.result = JSON.parse(res.result) //由于目前各个终端尚未完全兼容，需要开发者额外判断result类型以保证在各个终端的兼容性
						}
						var user = res.result.userList[0];
						dataVal.Values.push([user.id, user.name]);
						dataVal.Value = user.name;
					}
				})
			},
			getTemplate: async function() {
				this.listLoading = true;
				var title = this.logInfo.fullName;
				var departs=this.logInfo.fullName.split("/");
				var jobLevel = this.logInfo.JobLevel;
				if (departs.indexOf("房友圈") == -1 &&
					departs.indexOf("藤云") == -1 &&
					departs.indexOf("工商铺商业运营中心") == -1 &&
					departs.indexOf("代理") == -1 &&
					departs.indexOf("二级市场营运中心") == -1 &&
					this.isDisabled == false
				) {
					this.Message({
						message: '没有申请权限',
						type: 'error',
						duration: 1000
					});
					this.isDisabled = true;
				}
				await getTemplateInfo(this.templateId).then(async response => {
					var controls = response.Body;
					this.templateData = this.assignControl(controls, this.logInfo);
					var newControl = JSON.stringify(this.templateData.TemplateContent.Controls[5]);
					newControl = JSON.parse(newControl);
					newControl.Property.Require=0;
					newControl.Property.Control = "Image";
					await this.getEmployeeRelation();
					getImageMediaId().then(response=>{
						response.Body.forEach(media=>{
							this.medias.push(media.MediaId);
						});
					});
					this.templateData.TemplateContent.Controls.splice(6, 0, newControl);
					this.templateData.TemplateContent.Controls.forEach((item)=>{

						var departs = this.logInfo.fullName.split("/");
						if (item.Property.Title[0].Text == "暂缓时间") {
							item.IsShow = false;
						}
						if (item.Property.Title[0].Text == "暂缓截止时间") {
							item.IsShow = false;
						}
						if (item.Property.Title[0].Text == "暂缓诉讼截止时间") {
							item.IsShow = false;
						}
						if (item.Property.Title[0].Text == "流程编号") {
							item.IsShow = false;
						}
						if (item.Property.Title[0].Text == "达结佣条件9个月") {
							item.IsShow = false;
						}
						if (item.Property.Title[0].Text == "达结佣条件10个月及以上") {
							item.IsShow = false;
						}
						if (item.Property.Title[0].Text == "达结佣条件6个月") {
							item.IsShow = false;
						}
						if (item.Property.Title[0].Text == "达结佣条件7-8个月") {
							item.IsShow = false;
						}
						if (item.Property.Title[0].Text == "请选择审批行政助理") {
							if (departs.indexOf("住宅部") > -1) {
								item.IsShow = true;
							} else {
								item.Values = [];
								item.Values.push(this.$store.state.defaultMember);
								item.Value = "默认总经理"
								item.IsShow = false;
							}
						}
						if (item.Property.Title[0].Text == "逐级审批使用") {
							item.Values = [];
							if (departs.indexOf("工商铺商业运营中心") > -1) {
								item.Values = this.getRelationList(this.relationList, 6);
							}
							if (departs.indexOf("二级市场营运中心") > -1 || departs.indexOf("代理") > -1) {
								item.Values = this.getRelationList(this.relationList, 8);
							}
							if (departs.indexOf("房友圈") > -1 || departs.indexOf("藤云") > -1) {
								item.Values = this.getRelationList(this.relationList, 7);
							}
							if (item.Values == null || item.Values.length <= 0) {
								//审批节点无人，跳过
								item.Values.push(this.$store.state.defaultMember);
							}
							item.IsShow = false;
						}
					});
					this.templateData = await this.assignControlBySpNo(controls, this.spNo);
					this.listLoading = false;
				});
				
			},
			getEmployeeRelation: async function() {
				await getRelation(this.logInfo.EmpNo).then(response => {
					this.relationList = response.Body[0].Nodes;
				});
			},
			getTextVal() {},
			getSelectorVal(val, name) {
				var controls = this.templateData.TemplateContent.Controls;
				var controlInfo = controls.filter(item => item.Property.Title[0].Text == name)[0];
				if (name == "达结佣条件时间段") {
					var isNine = false;
					var isTen = false;
					var isSix = false;
					var isSeven = false;
					controlInfo.Values.forEach(e =>{
						var option = controlInfo.Config.Selector.Options
							.forEach(item => {
								 if(item.Value[0].Text == "达结佣条件9个月" && item.Key == e[0]){
									 isNine = true;
								 }else if(item.Key == e[0] && item.Value[0].Text == "达结佣条件10个月及以上"){
									 isTen = true;
								 }else if(item.Key == e[0] && item.Value[0].Text == "达结佣条件6个月"){
									 isSix = true;
								 }else if(item.Key == e[0] && item.Value[0].Text == "达结佣条件7-8个月"){
									 isSeven = true;
								 }
							});
					})
					var controlSix = controls.filter(item => item.Property.Title[0].Text == "达结佣条件6个月")[0];
					var controlSeven = controls.filter(item => item.Property.Title[0].Text == "达结佣条件7-8个月")[0];
					var controlNine = controls.filter(item => item.Property.Title[0].Text == "达结佣条件9个月")[0];
					var controlTen = controls.filter(item => item.Property.Title[0].Text == "达结佣条件10个月及以上")[0];
					
					if(isSeven){
						controlSeven.IsShow = true;
						controlSeven.Config.Table.Children.forEach(children =>{
							children.Property.Require = 1
						})
					}else{
						controlSeven.IsShow = false;
						controlSeven.Config.Table.Children.forEach(children =>{
							children.Property.Require = 0
						})
					}
					if(isSix){
						controlSix.IsShow = true;
						controlSix.Config.Table.Children.forEach(children =>{
							children.Property.Require = 1
						})
					}else{
						controlSix.IsShow = false;
						controlSix.Config.Table.Children.forEach(children =>{
							children.Property.Require = 0
						})
					}
					if(isNine){
						controlNine.IsShow = true;
						controlNine.Config.Table.Children.forEach(children =>{
							children.Property.Require = 1
						})
					}else{
						controlNine.IsShow = false;
						controlNine.Config.Table.Children.forEach(children =>{
							children.Property.Require = 0
						})
					}
					if(isTen){
						controlTen.IsShow = true;
						controlTen.Config.Table.Children.forEach(children =>{
							children.Property.Require = 1
						})
					}else{
						controlTen.IsShow = false;
						controlTen.Config.Table.Children.forEach(children =>{
							children.Property.Require = 0
						})
					}
					// var controlNum = controls.filter(item => item.Property.Title[0].Text == "暂缓时间")[0]
					// var controlDate = controls.filter(item => item.Property.Title[0].Text == "暂缓截止时间")[0]
					// var controlDateStop = controls.filter(item => item.Property.Title[0].Text == "暂缓诉讼截止时间")[0]
					// var isLine=false;
					// if (option != null) {
					// 	isLine=true;
					// }
					// controlNum.IsShow = isLine;
					// controlDate.IsShow = isLine;
					// controlNum.Property.Require = isLine==true?1:0;
					// controlDate.Property.Require = isLine==true?1:0;
					
					// controlDateStop.IsShow=!isLine;
					// controlDateStop.Property.Require = isLine==true?0:1;
				}

			},
			tableOperation(val, type, datas) {
				if(type=='compute'){
					return;
				}
				this.tableoperation(val, type, datas, this);
			},
			submit() {
				//数据校验
				if (!this.submitValidate(this.templateData.TemplateContent.Controls)) {
					return;
				}
				this.templateData.TemplateContent.Controls.forEach(async item=>{
					if(item.Property.Control=="Image"){
						item.IsShow=false;
					}
					if (item.Property.Title[0].Text == "附件") {
						if(item.Values==null||item.Values.length<=0){
							item.Values=[];
						}
						this.medias.forEach(media=>{
							item.Values.push([media]);
						});
					}
				})
				if (isSubmit) {
					this.Message({
						message: '已提交',
						type: 'warning',
						duration: 1000
					});
					return;
				}
				// 内容：流程编号+项目名称如：【124578】 楹联估计项目
				// 申请部门：业务支持部
				// 申请时间：2019-01-10 10:0:00
				var SummaryList = [];
				var info={SummaryInfo:[]}
				info.SummaryInfo=[];
				
				var control1=this.templateData.TemplateContent.Controls.filter(t=>{return t.Property.Title[0].Text == "项目名称"})[0]
				var info={SummaryInfo:[]}
				info.SummaryInfo=[];
				info.SummaryInfo.push({"Text":"内容：流程编号 "+control1.Value,"Lang":"zh_CN"});
				SummaryList.push(info);
				
				var control2=this.templateData.TemplateContent.Controls.filter(t=>{return t.Property.Title[0].Text == "部门"})[0]
				var info={SummaryInfo:[]}
				info.SummaryInfo=[];
				info.SummaryInfo.push({"Text":"申请部门："+control2.Value,"Lang":"zh_CN"});
				SummaryList.push(info);
				
				var control3=this.templateData.TemplateContent.Controls.filter(t=>{return t.Property.Title[0].Text == "申请时间"})[0]
				var info={SummaryInfo:[]}
				info.SummaryInfo=[];
				info.SummaryInfo.push({"Text":"申请时间："+control3.Value,"Lang":"zh_CN"});
				SummaryList.push(info);
				this.templateData.SummaryList=SummaryList;				
				
				isSubmit = true;
				this.listLoading = true;
				//提交
				submitProcess(this.templateId, this.logInfo.EmpNo, this.spNo, this.templateData).then(response => {
					this.Message({
						message: '申请成功',
						type: 'success',
						duration: 3 * 1000
					});
					setTimeout(() => {
						this.$router.push("/index");
					}, 3000)
				}).finally(() => {
					isSubmit = false;
					this.listLoading = false;
				});
			}
		}
		
	}
</script>

<style scoped lang="less">
	.pages {
		padding-bottom: 14px;
	}
</style>
